module.exports = __webpack_public_path__ + "static/media/banner-home.e97420c1.jpg";